import React, { useEffect, useState } from "react";
import Header from "../../Components/Header";
import Sidebar from "../../Components/Sidebar";
import { Constants } from "../../CommonMethhods/Constants";
import ReportTableHeader from "../../Components/ReportTables/ReportTableHeader";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import {
  Client_Search,
  Dashboard_Client_Report,
} from "../../Configuration/API_URL";
import { toast } from "react-toastify";
import AgingReportTable from "../../Components/ReportTables/AgingReportTable";
import Loader from "../../Components/Common/Loader";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import {
  AESEncryption,
  ApiResDecrypt,
} from "../../CommonMethhods/CommonMethods";
import { useDebounce } from "../../Components/useDebounce";
import axiosInstance from "../../CommonMethhods/axiosInstance";

function AgingReportSidebar() {
  const [loader, setLoader] = useState(false);
  const storeToken = localStorage.getItem("ssoToken");
  const [checkResp, setCheckResp] = useState([]);
  const [singleListing, setSingleListing] = useState([]);
  const [listingError, setListingError] = useState("");
  const [searchLoader, setSearchLoader] = useState(false);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [gridError, setGridError] = useState("");
  const [show, setShow] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [clientCode, setClientCode] = useState();
  const [smallLoader, setSmallLoader] = useState({ pdf: false, excel: false });
  const [clientCount, setClientCount] = useState();

  const debouncedValue= useDebounce(clientCode, 1000);

  useEffect(()=>{
    handleOnChange(debouncedValue)
  }, [debouncedValue])

  async function getAgingReportApiMain(code, fileType) {
    if (fileType === "excel") {
      setSmallLoader({ pdf: false, excel: true });
      setLoader(false);
    } else if (fileType === "pdf") {
      setSmallLoader({ pdf: true, excel: false });
      setLoader(false);
    } else {
      setSmallLoader({ pdf: false, excel: false });
    }
    let payloadValue = {
      clientCode: clientCode,
      stockName: "",
      fileType: fileType,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axiosInstance.post(
        Dashboard_Client_Report.Aging_Report_URL,

        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getDetails?.data);
      if (res?.data) {
        if (fileType === "grid") {
          setSingleListing((prev) => {
            return [...prev, ...res?.data];
          });
        } else if (fileType === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        } else if (fileType === "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        }
      } else {
        if (res?.message) {
          setCheckResp([]);
          setSingleListing([]);
          if (fileType === "grid") {
            setGridError("Aging details does not exist.");
          } else if (fileType === "excel") {
            toast.error("Aging details does not exist.");
          } else if (fileType === "pdf") {
            toast.error("Aging details does not exist.");
          }
        }
      }
    } catch (error) {
      console.log(error);
      if (fileType === "excel") {
        toast.error("Something went wrong, Please try again later.");
      }
      if (fileType === "pdf") {
        toast.error("Something went wrong, Please try again later.");
      }
      if (code !== "" && fileType === "grid") {
        setGridError("Something went wrong, Please try again later.");
      }
      setCheckResp([]);
    } finally {
      setLoader(false);
      setSearchLoader(false);
      setScrollLoader(false);
      setSmallLoader({ pdf: false, excel: false });
    }
  }

  async function searchApiDetail(e) {
    let payloadValue = {
      keyword: e.toUpperCase(),
      Status: "",
      PageNo: pageNo,
      PageSize: 10,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getSearchDetail = await axiosInstance.post(
        Client_Search.Search_URL,
        `"${encPayload}"`,

      );

      const res = ApiResDecrypt(getSearchDetail?.data);
      setClientCount(res.data.TotalCount);

      if (res.data) {
        if (res.data.clients) {
          setCheckResp((prev) => {
            return [...prev, ...res.data.clients];
          });
        } else {
          setCheckResp(res.data.clients);
          // setServerError("");
        }
      } else {
        setCheckResp([]);
        setListingError("No data found");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setSearchLoader(false);
      setScrollLoader(false);
    }
  }

  const handleOnChange = (data) => {
    // setCheckResp([]);
    setGridError(false);
    setScrollLoader(false);
    
    // e.target.value = e.target.value.toUpperCase();
    if (data?.length > 2) {
      searchApiDetail(data);
      setCheckResp([]);
      setSearchLoader(true);

      setShow(true);
    } else {
      setCheckResp([]);
      setShow(false);
    }
  };

  const handleOnClick = (e) => {
    let clientCodeApi = document.getElementById(
      "SearchInput_AgingReport"
    ).value;
    if (clientCodeApi !== "") {
      getAgingReportApiMain(clientCodeApi, e.target.value);
    } else {
      toast.error("Please enter Client Code/Name");
    }
  };

  function selectItem(item) {
    console.log(item.clientCode, "clientCode");
    document.querySelector("#SearchInput_AgingReport").value = item.clientCode;
    setShow(false);
    setLoader(true);
    getAgingReportApiMain(item.clientCode, "grid");
  }
  const handleScroll = async () => {
    const a = document.querySelector("#browsers-ap");
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
      if (clientCount <= pageNo * 10) {
        setScrollLoader(false);

        return;
      }
      setPageNo((prev) => prev + 1);
      setScrollLoader(true);
    }
  };
  useEffect(() => {
    if (pageNo > 1) {
      searchApiDetail(clientCode);
    }
  }, [pageNo]);

  return (
    <>
      <Header portal={"RM"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content" className="reports">
        <div className="card-box">
          <div>
            <h2 className="report-title">Aging Report</h2>
          </div>
          <div className="row input-field-wrapper">
            <div className="col-md-4 col-sm-6">
              <div className="form-group">
                <label className="form-label">{Constants.Client_Name}</label>
                <div className="rm-custom-dropdown">
                  <input
                    type="text"
                    name="search-text"
                    id="SearchInput_AgingReport"
                    className="input-st"
                    placeholder="Search here..."
                    autoComplete="off"
                    value={clientCode}
                    onChange={(e) => {
                      setClientCode(e?.target?.value?.toUpperCase());
                      // handleOnChange(e);
                    }}
                    onInput={(e) => {
                      const start = e.target.selectionStart;
                      const end = e.target.selectionEnd;
                      let input = e.target.value;
                      input = input
                          .toUpperCase()
                          .replace(/[^A-Z0-9\s]/g, "")
                          .replace(/\s+/g, " ")
                          .trimStart()
                          .slice(0, 100);

                      e.target.value = input;
                      e.target.setSelectionRange(start, end);
                      
                  }}
                  />

                  {show && (
                    <>
                      <ul
                        className="rm-mapping-ap border-0"
                        id="browsers-ap"
                        onScroll={handleScroll}
                      >
                        {/* {checkResp.lenght > 0 ? ( */}
                        {checkResp && checkResp.length > 0 ? (
                          checkResp.map((item, i) => (
                            <li
                              key={i}
                              onClick={() => selectItem(item)}
                              className="rm-maping-item-wrapper"
                            >
                              <div> {item.clientname}</div>
                              <div> {item.clientCode}</div>
                            </li>
                          ))
                        ) : searchLoader ? (
                          <div className="loader-center">
                            <LoaderForSearch />
                          </div>
                        ) : (
                          <li className="rm-maping-item-wrapper">
                            {listingError}
                          </li>
                        )}
                        {scrollLoader && (
                          <div className="loader-center">
                            <LoaderForSearch />
                          </div>
                        )}
                      </ul>
                    </>
                  )}
                </div>
                {/* <span className="to-date-error">{error}</span> */}
              </div>
            </div>
          </div>
          <div>
            <ReportTableHeader
              showEmailBtn={false}
              smallLoaderExcel={smallLoader["excel"]}
              smallLoaderPdf={smallLoader["pdf"]}
              handleOnClick={handleOnClick}
            />
          </div>
          <div className="for-grid-section">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : singleListing ? (
              <div>
                <AgingReportTable
                  singleListing={singleListing}
                  // handleScroll={handleScroll}
                  // scrollLoader={scrollLoader}
                />
              </div>
            ) : (
              ""
            )}
            {gridError && (
              <h4 className="report-error-message">
                Aging details does not exist.
              </h4>
            )}
          </div>
        </div>
      </main>
    </>
  );
}

export default AgingReportSidebar;
